import { Map } from "immutable";
import moment from "moment";
import { AsyncState, loadingAsyncState, none, Option, some } from "widgets-for-react";
import { MapPage, SimpelPageMap, visit_option } from "../../../../utils";
import { getParameterByName, insertUrlParam, removeUrlParams } from "../../../cms/blocks/utils.gen";
import { getFormState } from "../../../form/api";
import { FieldData, StepData } from "../../../form/types";
import { WordPress } from "../../../wordpress/wordpress_api";
import { BrochureWebshopState } from "./brochuresWebshop.widget";

export const setBrochureWebShopState = <K extends keyof BrochureWebshopState>(key: K, value: BrochureWebshopState[K]) => (s: BrochureWebshopState): BrochureWebshopState => {
    if (key == 'selected_term') {
        let param = value as Option<number>
        visit_option<number, void>(param)(v => {
            insertUrlParam('term', v.toString())
        }, () => {
            removeUrlParams('term')
        })
        return ({
            ...s, [key]: param,
            current_page: 1,
            total_pages: none(),
            brochures: Map<number, AsyncState<SimpelPageMap<string, WordPress.BrochureResponse>>>()
                .set(s.current_page, get_brochures(1, s.size, s.country, visit_option<number, number | undefined>(param)(v => v, () => undefined))),
            total_items: 0
        })
    }
    if (key == 'current_page') {
        let filter = s.selected_term
        let term = getParameterByName('term')
        if (term != '' && !isNaN(Number(term))) {
            filter = some(Number(term))
        }

        return ({
            ...s,
            [key]: value,
            selected_term: filter,
            brochures: s.brochures.set(s.current_page, get_brochures(value as number, s.size, s.country, visit_option<number, number | undefined>(filter)(v => v, () => undefined)))
        })
    }
    if (key == 'shopping_cart') {
        sessionStorage.setItem('shoppingcart', JSON.stringify(value))
    }
    if (key == 'step') {
        const lang = window.wp.language || 'en'

        let productFormData: StepData[] = [{
            step: { title: 'Order', orderNumber: 1, Id: 1, CreatedDate: moment() },
            dependencies: [],
            fields: [
                <FieldData>{
                    Kind: 'Text',
                    Id: 1,
                    CreatedDate: moment(),
                    Description: "",
                    title: `fc_order_Bestelling`,
                    itemOrderNumber: 0,
                    placeholder: "",
                    maybe_answers: [],
                    width_percentage: 'Small',
                    optionalDefaultValue: '',
                    hidden: true,
                    user_input: s.shopping_cart.toIndexedSeq().reduce((xs, x) => xs.set(x.product_id, x.quantity.toString()), Map<string, string>()).toJS(),
                }
            ]
                .concat(
                    s.shopping_cart
                        .toIndexedSeq()
                        .toArray()
                        .map((shop_item, i) => ({
                            Kind: 'Text',
                            Id: i,
                            CreatedDate: moment(),
                            Description: "",
                            title: `Ordered Item #${shop_item.product_id}`,
                            itemOrderNumber: 0,
                            placeholder: "",
                            maybe_answers: [],
                            width_percentage: 'Small',
                            optionalDefaultValue: '',
                            hidden: true,
                            user_input: `${shop_item.quantity}x ${shop_item.title} #${shop_item.product_id}`
                        }))
                )
        }]

        return ({ ...s, [key]: value, form: getFormState([], `WebshopForm_${get_impress_country_code(s.country_name)}`, productFormData) })
    }

    return ({ ...s, [key]: value })
}

export const get_brochures = (current_page: number, size: number, country: number, term?: number): AsyncState<SimpelPageMap<string, WordPress.BrochureResponse>> => loadingAsyncState(() => WordPress.api<WordPress.BrochureResponse>().select('brochures').where({
    page: current_page,
    per_page: size,
    brochures_taxonomy: [term],
    country_taxonomy: country
}).getMultiple().then(d => {
    if (d.status != 200) return ({ kind: 'failed', status: d.status })
    let total_pages = Number(d.headers['x-wp-totalpages'])
    let total_items = Number(d.headers['x-wp-total'])
    return ({ kind: 'result', status: d.status, value: MapPage(Map(d.data.reduce((xs, x) => ({ ...xs, [x.id]: x }), {} as object)), total_pages, total_items) })
}))

export const get_impress_country_code = (country: string) =>
{
    switch(country) {
        case 'Belgium French':
            return 'be-fr'
        case 'België':
            return 'be-nl'
        default:
            return 'nl'
    }
}